import { useChannel } from "./useChannel";

const useChannelCurrency = () => {
    const channel = useChannel();

    return channel.currencies.default_currency;
};

export default useChannelCurrency;
